import React from 'react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export const AdminPDFRequests = () => {
  const [requests, setRequests] = React.useState([]);
  const [loading, setLoading] = React.useState(true);

  React.useEffect(() => {
    fetchRequests();
  }, []);

  const fetchRequests = async () => {
    try {
      const response = await axios.get(`${API}/pdf-guide-requests`);
      setRequests(response.data);
      setLoading(false);
    } catch (error) {
      console.error('Error fetching requests:', error);
      setLoading(false);
    }
  };

  const formatDate = (timestamp) => {
    const date = new Date(timestamp);
    return date.toLocaleString('de-DE');
  };

  return (
    <div style={{
      minHeight: '100vh',
      padding: 'var(--spacing-giant) 0',
      background: 'var(--bg-page)'
    }}>
      <div className="container" style={{ maxWidth: '1200px' }}>
        <h1 className="display-medium" style={{ marginBottom: 'var(--spacing-xl)' }}>
          PDF-Guide Anfragen
        </h1>

        {loading ? (
          <p className="body-large">Lade Anfragen...</p>
        ) : requests.length === 0 ? (
          <div className="network-card" style={{ cursor: 'default', textAlign: 'center' }}>
            <p className="body-large">Noch keine Anfragen vorhanden.</p>
          </div>
        ) : (
          <div style={{ display: 'flex', flexDirection: 'column', gap: 'var(--spacing-medium)' }}>
            {requests.map((request, index) => (
              <div key={index} className="network-card" style={{ cursor: 'default' }}>
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: 'var(--spacing-medium)' }}>
                  <div>
                    <div style={{ fontSize: '0.875rem', color: 'var(--text-light)', marginBottom: '4px' }}>
                      Name
                    </div>
                    <div className="body-medium" style={{ fontWeight: 600 }}>
                      {request.firstName} {request.lastName}
                    </div>
                  </div>
                  
                  <div>
                    <div style={{ fontSize: '0.875rem', color: 'var(--text-light)', marginBottom: '4px' }}>
                      E-Mail
                    </div>
                    <div className="body-medium">
                      <a href={`mailto:${request.email}`} style={{ color: 'var(--brand-dark)', textDecoration: 'none' }}>
                        {request.email}
                      </a>
                    </div>
                  </div>
                  
                  <div>
                    <div style={{ fontSize: '0.875rem', color: 'var(--text-light)', marginBottom: '4px' }}>
                      Telefon
                    </div>
                    <div className="body-medium">
                      {request.phone || 'Nicht angegeben'}
                    </div>
                  </div>
                  
                  <div>
                    <div style={{ fontSize: '0.875rem', color: 'var(--text-light)', marginBottom: '4px' }}>
                      Datum
                    </div>
                    <div className="body-medium">
                      {formatDate(request.timestamp)}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}

        <div style={{ marginTop: 'var(--spacing-xl)', textAlign: 'center' }}>
          <button 
            onClick={fetchRequests}
            className="btn-primary"
          >
            Aktualisieren
          </button>
        </div>
      </div>
    </div>
  );
};
